import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {map, take} from 'rxjs';

import {selectCurrentProjectsRoute} from '../store/projects/projects.selector';
import {MENU_PATHS} from 'src/app/app.constants';

export const projectsRouteGuard: CanActivateFn = (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectCurrentProjectsRoute).pipe(
    take(1),
    map(storedRoute => {
      if (storedRoute && storedRoute !== MENU_PATHS.Projects && state.url !== storedRoute) {
        return router.parseUrl(storedRoute);
      }
      return true;
    })
  );
};
